import React from 'react';
import { Link, Control, Preloader } from 'MWC';
import FAQ from '../../views/faq.c';
import Calculator from '../../../../auxiliary-components/Calculator';
import Breadcrumbs from "../../../../auxiliary-components/Breadcrumbs"
import { MAIN, CARDS, KUN_CARD } from '../../../../auxiliary-components/Breadcrumbs/collection/breadcrumbs.config';
import replaceDotWithComma from "../../../../helpers/utils/replaceDotWithComma";
import '../../less/kun.less';
import { LANG } from '../../../../services/l10n';
import Banner from "../../../../auxiliary-components/shared/Banner";
import TabsNew from "../../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../../auxiliary-components/shared/UsageBlock";
import kun_usage_block_data from "../../enums/kun_usage_block_data.json";
import TextAboveFooter from "../../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import Table from "../../../../auxiliary-components/shared/Table";
import table_data from "../../enums/kun_table_data.json";
import share_icon from "../../ProjectSupport/img/share_icon.svg";
import DownloadApp from "../../views/downloadApp.c";
import QuestionsBlock from "../../../../auxiliary-components/shared/QuestionsBlock";
import questions from "../../enums/kun_questions.json";
import FilesForDownload from "../../../../auxiliary-components/shared/FilesForDownload/views/file.c";

export default function template() {
    const isMobile = this.isViewportMobile(),
        model = this.getModel(),
        modes = [ {mode: 'info', title: 'KUN_CARD_NAV_TITLE_1'},
              {mode: 'tariffs', title: 'KUN_CARD_NAV_TITLE_2'},
              {mode: 'questions', title: 'KUN_CARD_NAV_TITLE_3'}],
        page = 'kun',
        links = [MAIN, CARDS, KUN_CARD],
        tariffs = 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Univer_ua.pdf',
        calculator = !model.creditSum ? (
          ''
        ) : (
          <div className="credit-calculator">
              <div className="calculator-wrapper">
                  <Calculator model={this.getModel()} type="credit_cards" {...this.props} />
              </div>
          </div>
        ),
        app = (
          <div className="download-app-wrapper">
            <DownloadApp {...this.props} />
          </div>
        );

    return !model.creditSum ?
        <div className="preload-wrapper">
            <Preloader />
        </div> :
        (
            <div className="kun-card">
                { isMobile ? <Breadcrumbs links={links} {...this.props} /> : ''}
                <Banner
                  text={'CARDS_UNIVERSAL_SUBTITLE'}
                  textMob={'CARDS_UNIVERSAL_SUBTITLE_MOB'}
                  title={'CARDS_UNIVERSAL_TITLE'}
                  toggleModal={null}
                  page={page}
                  isMobile={isMobile}>
                </Banner>
                <TabsNew modes={modes} isMobile={isMobile} page={page} toggle={this.toggleMode} mode={this.state.mode}>
                    <div className="wrapper" type={modes[0].mode}>
                        <div className="content">
                            <UsageBlock isMobile={isMobile} page={page} data={kun_usage_block_data} className="col-3-row-2"></UsageBlock>
                            {calculator}
                        </div>
                    </div>
                    <div className="wrapper" type={modes[1].mode}>
                      <div className="content">
                        <Table data={table_data} page={page} isMobile={isMobile} toggle={this.toggleMode}></Table>
                        <div className="tariffs-desc">
                          {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_1')}
                          <a className="link" href={tariffs} target="_blank">
                            {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_2')}
                            <img alt="href_img" src={share_icon}></img>
                          </a>
                        </div>
                      </div>
                      {app}
                    </div>
                    <div className="wrapper" type={modes[2].mode}>
                      <div className="content">
                        <QuestionsBlock isMobile={isMobile} page={page} data={questions}></QuestionsBlock>
                      </div>
                      {app}
                    </div>
                </TabsNew>
              <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}></FilesForDownload>
                <div className={`disclaimer-wrapper tab-${this.state.mode === 'info' ? 'active' : 'hidden'}`}>
                  <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')} isMobile={isMobile}></TextAboveFooter>
                </div>
            </div>
        );
}
